import React, { useState, useCallback, useEffect } from 'react'
import { House, CakeCandles, Star, Gifts, Horn, PollVertical, Envelope, Pinned, CalendarAlt, LocationDot, Clock, UserTie, Heart, At, Inbox, Plus } from '../../../components/icons/Icons'
import {
  getNotificationsPath,
  notifyApproveRequestPath,
} from "../../../services/config";
import { useDispatch, useSelector } from 'react-redux';
import { getAncemntNotiCountData, initNotiCountState } from '../../../redux/slices/announcementSlice';
import { useSelect } from '../../../services/commonServices';

// ── Scrollbar styles injected once ──────────────────────────
const scrollbarStyle = `
  .left-bar-scroll::-webkit-scrollbar {
    width: 4px;
  }
  .left-bar-scroll::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 4px;
  }
  .left-bar-scroll::-webkit-scrollbar-thumb {
    background: rgba(134, 96, 248, 0.45);
    border-radius: 4px;
  }
  .left-bar-scroll::-webkit-scrollbar-thumb:hover {
    background: rgba(134, 96, 248, 0.75);
  }
`

const LeftBar = ({ activeTab, handleActiveTab, notificationCounts, collapsed, setCollapsed }) => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const dispatch = useDispatch()
  const ancemntStore = useSelect("announce")

  const [notiCounts, setNotiCounts] = useState({
    Leave: 0, Regularization: 0, Offsite: 0, Permission: 0, Other: 0,
  });

  const [postList, setPostList] = useState([
    { id: 1, lable: "All Posts",     value: "allPosts", count: "0", icon: <House class_name={"icon"} />,        iconColor: "#8660F8" },
    { id: 2, lable: "Birthdays",     value: "allPosts", count: "0", icon: <CakeCandles class_name={"icon"} />,  iconColor: "#FAC775" },
    { id: 3, lable: "Appreciations", value: "allPosts", count: "0", icon: <Star class_name={"icon"} />,         iconColor: "#C0DD97" },
    { id: 4, lable: "Festivals",     value: "allPosts", count: "0", icon: <Gifts class_name={"icon"} />,        iconColor: "#F4C0D1" },
    { id: 5, lable: "Announcements", value: "allPosts", count: "0", icon: <Horn class_name={"icon"} />,         iconColor: "#AFA9EC" },
    { id: 6, lable: "Polls",         value: "allPosts", count: "0", icon: <PollVertical class_name={"icon"} />, iconColor: "#9FE1CB" },
    { id: 7, lable: "Message",       value: "allPosts", count: "0", icon: <Envelope class_name={"icon"} />,     iconColor: "#B5D4F4" },
    { id: 8, lable: "Pinned Posts",  value: "allPosts", count: "0", icon: <Pinned class_name={"icon"} />,       iconColor: "#F5C4B3" },
  ])

  const [systemRequest, setSystemRequest] = useState([])

  const [messageFilter, setMessageFilter] = useState([
    { id: 1, lable: "Inbox",        value: "inbox",        count: "0", icon: <Inbox class_name={"icon"} />,   iconColor: "#60A5FA" },
    { id: 2, lable: "HR Notices",   value: "hrNotices",    count: "0", icon: <UserTie class_name={"icon"} />, iconColor: "#F87171" },
    { id: 3, lable: "Personalized", value: "personalized", count: "0", icon: <Heart class_name={"icon"} />,   iconColor: "#F472B6" },
    { id: 4, lable: "Mentions",     value: "mentions",     count: "0", icon: <At class_name={"icon"} />,      iconColor: "#8660F8" },
  ])

  const getNotification = useCallback(() => {
    const path = `${getNotificationsPath}${user.user_id}`;
    dispatch(getAncemntNotiCountData(path));
  }, [dispatch, user.user_id]);

  useEffect(() => { getNotification() }, [])

  useEffect(() => {
    if (ancemntStore.notiCountSuccess) {
      const leave          = ancemntStore.notiCountData?.leaveRequests?.filter(v => v.referenceId === "1" && v.approved === "0") || [];
      const regularization = ancemntStore.notiCountData?.leaveRequests?.filter(v => v.referenceId === "2") || [];
      const offsite        = ancemntStore.notiCountData?.leaveRequests?.filter(v => v.referenceId === "3" && v.approved === "0") || [];
      const permission     = ancemntStore.notiCountData?.leaveRequests?.filter(v => v.referenceId === "4" && v.approved === "0") || [];
      const other          = ancemntStore.notiCountData?.leaveRequests?.filter(v => !["1","2","3","4"].includes(v.referenceId)) || [];

      setSystemRequest([
        { id: 1, lable: "Leave Requests",         value: "leave",          count: leave.length,          icon: <CalendarAlt class_name={"icon"} />, iconColor: "#F87171" },
        { id: 2, lable: "Offsite Requests",        value: "offsite",        count: offsite.length,        icon: <LocationDot class_name={"icon"} />, iconColor: "#FB923C" },
        { id: 3, lable: "Regularisation Requests", value: "regularisation", count: regularization.length, icon: <Clock class_name={"icon"} />,       iconColor: "#FACC15" },
        { id: 4, lable: "Others",                  value: "halfDay",        count: other.length,          icon: <Clock class_name={"icon"} />,       iconColor: "#60A5FA" },
      ])
      setNotiCounts(pre => ({
        ...pre,
        Leave: leave.length, Regularization: regularization.length,
        Offsite: offsite.length, Permission: permission.length, Other: other.length,
      }));
      dispatch(initNotiCountState())
    }
  }, [ancemntStore])

  const [activeItam, setActiveItem] = useState("All Posts");
  const handleActiveItem = (item) => { setActiveItem(item); handleActiveTab(item); }

  // ── Section label ──────────────────────────────────────────
  const sectionLabel = (text, accent = false) => (
    <p style={{
      fontSize: "11px", fontWeight: 500, letterSpacing: "0.08em",
      textTransform: "uppercase", margin: "0 0 6px",
      color: accent ? "#8660F8" : "#6b7280",
      padding: collapsed ? "0" : "0 8px",
      textAlign: collapsed ? "center" : "left",
      transition: "all 0.3s ease",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }}>{collapsed ? "" : text}</p>
  )

  // ── Nav Item ───────────────────────────────────────────────
  const NavItem = ({ icon, label, isActive, onClick, count, iconColor }) => (
    <li
      onClick={onClick}
      title={collapsed ? label : ""}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: collapsed ? "center" : "space-between",
        padding: collapsed ? "8px" : "7px 10px",
        borderRadius: "8px",
        cursor: "pointer",
        background: isActive ? "rgba(134,96,248,0.12)" : "transparent",
        transition: "all 0.2s ease",
        listStyle: "none",
        position: "relative",
      }}
      onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
      onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = isActive ? "rgba(134,96,248,0.12)" : "transparent"; }}
    >
      {/* Icon box */}
      <span style={{
        width: "28px", height: "28px", borderRadius: "7px", flexShrink: 0,
        background: isActive ? "rgba(134,96,248,0.2)" : iconColor ? `${iconColor}22` : "rgba(255,255,255,0.06)",
        display: "flex", alignItems: "center", justifyContent: "center",
        color: isActive ? "#c4b5fd" : iconColor || "#9ca3af",
      }}>
        {icon}
      </span>

      {/* Label */}
      {!collapsed && (
        <span style={{
          flex: 1, marginLeft: "9px",
          fontSize: "13px", color: isActive ? "#c4b5fd" : "#9ca3af",
          fontWeight: isActive ? 500 : 400, whiteSpace: "nowrap",
          overflow: "hidden", textOverflow: "ellipsis",
        }}>
          {label}
        </span>
      )}

      {/* Badge */}
      {!collapsed && Number(count) > 0 && (
        <span style={{
          fontSize: "11px", fontWeight: 600, padding: "1px 6px",
          borderRadius: "20px", flexShrink: 0,
          background: iconColor ? `${iconColor}30` : "rgba(134,96,248,0.2)",
          color: iconColor || "#8660F8",
        }}>
          {count}
        </span>
      )}

      {/* Collapsed badge dot */}
      {collapsed && Number(count) > 0 && (
        <span style={{
          position: "absolute", top: "4px", right: "4px",
          width: "7px", height: "7px", borderRadius: "50%",
          background: iconColor || "#8660F8",
        }} />
      )}
    </li>
  )

  const Divider = () => (
    <div style={{ height: "0.5px", background: "rgba(255,255,255,0.08)", margin: "8px 0" }} />
  )

  return (
    <>
      {/* ── Inject scrollbar CSS once ── */}
      <style>{scrollbarStyle}</style>

      <div style={{
        width: collapsed ? "60px" : "240px",
        height: "100vh",               // ✅ fixed height so inner scroll works
        position: "sticky",            // ✅ sticks to top while page scrolls
        top: 0,
        background: "rgba(255,255,255,0.02)",
        borderRight: "0.5px solid rgba(255,255,255,0.08)",
        display: "flex",
        flexDirection: "column",
        transition: "width 0.3s ease",
        overflow: "hidden",
        flexShrink: 0,
        zIndex: 10,
      }}>

        {/* ── Toggle Button ─────────────────────────── */}
        <div style={{
          display: "flex",
          justifyContent: collapsed ? "center" : "flex-end",
          padding: "12px 10px 8px",
          flexShrink: 0,
        }}>
          <button
            onClick={() => setCollapsed(prev => !prev)}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            style={{
              width: "28px", height: "28px", borderRadius: "7px",
              border: "0.5px solid rgba(255,255,255,0.12)",
              background: "rgba(255,255,255,0.05)",
              color: "#9ca3af", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              transition: "all 0.2s ease", flexShrink: 0,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(134,96,248,0.15)"; e.currentTarget.style.color = "#8660F8"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; e.currentTarget.style.color = "#9ca3af"; }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              {collapsed
                ? <polyline points="9 18 15 12 9 6" />
                : <polyline points="15 18 9 12 15 6" />
              }
            </svg>
          </button>
        </div>

        {/* ── Scrollable Content ────────────────────── */}
        <div
          className="left-bar-scroll"
          style={{
            flex: 1,
            overflowY: "scroll",         // ✅ always shows scrollbar track
            overflowX: "hidden",
            padding: collapsed ? "0 6px" : "0 10px",
            transition: "padding 0.3s ease",
            scrollbarWidth: "thin",      // Firefox
            scrollbarColor: "rgba(134,96,248,0.45) rgba(255,255,255,0.03)", // Firefox
          }}
        >

          {/* Filter Posts */}
          {sectionLabel("Filter Posts")}
          <ul style={{ listStyle: "none", margin: "0 0 4px", padding: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
            {postList.map(item => (
              <NavItem
                key={item.id}
                icon={item.icon}
                label={item.lable}
                isActive={activeItam === item.lable}
                onClick={() => handleActiveItem(item.lable)}
                count={item.count}
                iconColor={item.iconColor}
              />
            ))}
          </ul>

          <Divider />

          {/* System Requests */}
          {sectionLabel("System Requests", true)}
          <ul style={{ listStyle: "none", margin: "0 0 4px", padding: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
            {systemRequest.map(item => (
              <NavItem
                key={item.id}
                icon={item.icon}
                label={item.lable}
                isActive={activeItam === item.value}
                onClick={() => handleActiveItem(item.value)}
                count={item.count}
                iconColor={item.iconColor}
              />
            ))}
          </ul>

          <Divider />

          {/* Message Filters */}
          {sectionLabel("Message Filters")}
          <ul style={{ listStyle: "none", margin: "0 0 4px", padding: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
            {messageFilter.map(item => (
              <NavItem
                key={item.id}
                icon={item.icon}
                label={item.lable}
                isActive={activeItam === item.lable}
                onClick={() => handleActiveItem(item.lable)}
                count={item.count}
                iconColor={item.iconColor}
              />
            ))}
          </ul>

          <Divider />

          {/* Quick Actions — expanded */}
          {!collapsed && (
            <div style={{
              background: "rgba(255,255,255,0.04)", borderRadius: "12px",
              padding: "12px", border: "0.5px solid rgba(255,255,255,0.08)",
              marginBottom: "12px",
            }}>
              <p style={{
                fontSize: "11px", fontWeight: 500, letterSpacing: "0.06em",
                textTransform: "uppercase", color: "#6b7280", margin: "0 0 10px"
              }}>
                Quick Actions
              </p>
              {[
                { icon: <Plus />, label: "Create Post",       primary: true  },
                { icon: <CakeCandles />, label: "Birthday Wish",     primary: false },
                { icon: <Star />, label: "Send Appreciation", primary: false },
              ].map((btn, i) => (
                <button key={i} style={{
                  width: "100%", padding: "8px 12px", borderRadius: "8px",
                  border: btn.primary ? "none" : "0.5px solid rgba(255,255,255,0.15)",
                  background: btn.primary ? "#8660F8" : "transparent",
                  color: btn.primary ? "#fff" : "#9ca3af",
                  fontSize: "13px", cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  marginBottom: i < 2 ? "7px" : "0",
                  transition: "background 0.15s",
                }}
                  onMouseEnter={e => e.currentTarget.style.background = btn.primary ? "#6d4fd4" : "rgba(255,255,255,0.06)"}
                  onMouseLeave={e => e.currentTarget.style.background = btn.primary ? "#8660F8" : "transparent"}
                >
                  {btn.icon} {btn.label}
                </button>
              ))}
            </div>
          )}

          {/* Quick Actions — collapsed icons only */}
          {collapsed && (
            <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "center", marginBottom: "12px" }}>
              {[
                { icon: <Plus />,       label: "Create Post",    color: "#8660F8" },
                { icon: <CakeCandles />, label: "Birthday Wish",  color: "#FAC775" },
                { icon: <Star />,       label: "Appreciation",   color: "#C0DD97" },
              ].map((btn, i) => (
                <button key={i} title={btn.label} style={{
                  width: "36px", height: "36px", borderRadius: "8px",
                  border: "0.5px solid rgba(255,255,255,0.12)",
                  background: i === 0 ? "rgba(134,96,248,0.15)" : "rgba(255,255,255,0.04)",
                  color: btn.color, cursor: "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "all 0.15s",
                }}
                  onMouseEnter={e => e.currentTarget.style.background = `${btn.color}22`}
                  onMouseLeave={e => e.currentTarget.style.background = i === 0 ? "rgba(134,96,248,0.15)" : "rgba(255,255,255,0.04)"}
                >
                  {btn.icon}
                </button>
              ))}
            </div>
          )}

        </div>
      </div>
    </>
  )
}

export default LeftBar